// extracted by mini-css-extract-plugin
module.exports = {"row":"SimpleQuestionBuilderModal_row__2nL4P","radioRow":"SimpleQuestionBuilderModal_radioRow__2I9MY"};